import script from "./logout-confirm-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./logout-confirm-modal.vue?vue&type=script&setup=true&lang=ts"

import "./logout-confirm-modal.vue?vue&type=style&index=0&id=15462a0a&lang=css"

const __exports__ = script;

export default __exports__